import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.817-12.688a.807.807 0 0 0-.101-1.127.782.782 0 0 0-1.112.103l-4.71 5.727-2.546-2.58a.782.782 0 0 0-1.117 0 .808.808 0 0 0 0 1.13l3.158 3.2a.784.784 0 0 0 1.165-.053l5.263-6.4Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n
];
function r(d, s) {
  return e(), t("svg", l, [...c]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
